<template>
  <div class="view-home winner-page">
    <div class="container">
      <div class="row about-page ">
        <div class="col-md-12">
          <div class="breadcrumb px-0 mb-4">
            <router-link to="/">{{ $t('breadcrumb.main-page') }}</router-link>
            <router-link to="/for-winner" class="active">{{ $t('breadcrumb.for-winners') }}</router-link>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h1 class="title about-title mb-4">{{ $t('for-winners.title') }}</h1>
            </div>
          </div>
          <div class="about-join py-5">
            <div class="container">
              <div class="row">
                <div class="col-lg-10 col-md-12 mx-auto">
                  <div class="about_olympiad_winners">
                    <p>{{ $t('about-page.about-info-title') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="about_slider">
            <carousel
                style="width: 100%;"
                :per-page="5"
                navigationEnabled='true'
                navigation-next-label=""
                navigation-prev-label=""
                paginationActiveColor="#2091F9"
                paginationColor="rgba(32, 145, 249, 0.2)"
                :navigateTo="manualNavigation"
            >
              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <!--              <img src="/images/winners/Аманбек Батыржан.jpg" alt="">-->
                    <div style="background-image: url('/images/winners/winner1.png')" class="winner-image"></div>
                  </div>
                </div>
              </slide>
              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <div style="background-image: url('/images/winners/winner2.png')" class="winner-image"></div>
                  </div>
                </div>
              </slide>
              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <div style="background-image: url('/images/winners/winner3.png')" class="winner-image"></div>
                  </div>
                </div>
              </slide>
              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <div style="background-image: url('/images/winners/winner4.png')" class="winner-image"></div>
                  </div>
                </div>
              </slide>
              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <div style="background-image: url('/images/winners/winner5.png')" class="winner-image"></div>
                  </div>
                </div>
              </slide>

              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <div style="background-image: url('/images/winners/winner6.png')" class="winner-image"></div>
                  </div>
                </div>
              </slide>

              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <div style="background-image: url('/images/winners/winner7.png')" class="winner-image"></div>
                  </div>
                </div>
              </slide>

              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <div style="background-image: url('/images/winners/winner8.jpg')" class="winner-image"></div>
                  </div>
                </div>
              </slide>

              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <div style="background-image: url('/images/winners/winner9.jpg')" class="winner-image"></div>
                  </div>
                </div>
              </slide>

              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <div style="background-image: url('/images/winners/winner10.jpg')" class="winner-image"></div>
                  </div>
                </div>
              </slide>
            </carousel>
          </div>

          <div class="about_slider_mobile">
            <carousel
                style="width: 100%;"
                :per-page="1"
                navigationEnabled='true'
                navigation-next-label=""
                navigation-prev-label=""
                paginationActiveColor="#2091F9"
                paginationColor="rgba(32, 145, 249, 0.2)"
                :navigateTo="manualNavigation"
            >
              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <img src="../../../public/images/winners/winner1.png" alt="">
                  </div>
                </div>
              </slide>
              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <img src="../../../public/images/winners/winner2.png" alt="">
                  </div>
                </div>
              </slide>
              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <img src="../../../public/images/winners/winner3.png" alt="">
                  </div>
                </div>
              </slide>
              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <img src="../../../public/images/winners/winner4.png" alt="">
                  </div>
                </div>
              </slide>
              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <img src="../../../public/images/winners/winner5.png" alt="">
                  </div>
                </div>
              </slide>

              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <img src="../../../public/images/winners/winner6.png" alt="">
                  </div>
                </div>
              </slide>


              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <img src="../../../public/images/winners/winner7.png" alt="">
                  </div>
                </div>
              </slide>


              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <img src="../../../public/images/winners/winner8.jpg" alt="">
                  </div>
                </div>
              </slide>


              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <img src="../../../public/images/winners/winner9.jpg" alt="">
                  </div>
                </div>
              </slide>


              <slide class="about_slide_olympiad_winner">
                <div class="about_slide_olympiad_winner_block">
                  <div class="about_slide_olympiad_winner_photo">
                    <img src="../../../public/images/winners/winner10.jpg" alt="">
                  </div>
                </div>
              </slide>
            </carousel>
          </div>


          <!--          <div class="row">-->
<!--            <div class="col-12" v-if="year==2021">-->
<!--              <h2 class="title title-light-blue mt-5 mb-4">{{ yearLabel }}</h2>-->
<!--              <p>{{ $t('for-winners.text-1') }}</p>-->
<!--              <p>{{ $t('for-winners.text-2') }}</p>-->
<!--              <p>{{ $t('for-winners.text-3') }}</p>-->
<!--              <p>{{ $t('for-winners.text-4') }}</p>-->
<!--            </div>-->
<!--            <div class="col-12" v-if="year==2022">-->
<!--              <h2 class="title title-light-blue mt-5 mb-4">{{ yearLabel }}</h2>-->
<!--              <p>{{ $t('for-winners.text-1-2022') }}</p>-->
<!--              <p>{{ $t('for-winners.text-2-2022') }}</p>-->
<!--              <p>{{ $t('for-winners.text-3-2022') }}</p>-->
<!--            </div>-->
<!--          </div>-->

        </div>
      </div>
    </div>

    <div class="map-container-wrap" v-show="mapTab=='finalists'">
      <div class="container-fluid map-container overflow-hidden">
        <div style="padding-top: 2rem" class="row position-relative">
          <div class="container-map-title">
            <h2 class="title">{{ $t('for-winners.finalist-geography') }} </h2>
            <div class="col-md-5" style="max-width: 250px;margin: auto">
              <span>{{ $t('for-winners.olimpiad-year') }}</span>
              <el-select
                  :value="year"
                  @input="setYear">
                <el-option
                    key="1"
                    :label="2021"
                    :value="'2021'"
                    @click="setYear('2021')">
                </el-option>
                <el-option
                    key="2"
                    :label="2022"
                    :value="'2022'"
                    @click="setYear('2022')">
                </el-option>
                <el-option
                    key="3"
                    :label="2023"
                    :value="'2023'"
                    @click="setYear('2023')">
                </el-option>

                <el-option
                    key="4"
                    :label="2024"
                    :value="'2024'"
                    @click="setYear('2024')">
                </el-option>
                <el-option
                    key="5"
                    :label="2025"
                    :value="'2025'"
                    @click="setYear('2025')">
                </el-option>
                <el-option
                    key="6"
                    :label="2026"
                    :value="'2026'"
                    @click="setYear('2026')">
                </el-option>
              </el-select>
            </div>
            <div class="container-map-buttons">
              <el-button
                  @click="mapTab='finalists'"
                  v-bind:class="{'btn-active':mapTab=='finalists'}"
                  type="primary"
                  class="container-map-button"
              >
                {{ $t('for-winners.finalist') }}
              </el-button>
              <el-button
                  @click="mapTab='winners'"
                  v-bind:class="{'btn-active':mapTab=='winners'}"
                  type="primary"
                  class="container-map-button"
              >
                {{ $t('for-winners.winners') }}
              </el-button>
            </div>

          </div>
          <div class="col-lg-9">

            <div id="canvas">

              <div id="paper" style="padding-top: 50px;"></div>
            </div>

            <div class="mapZooming">
              <button class="btn btn-zoomOut">
                <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.1609 0.593461C9.1944 0.747872 7.79743 1.17593 6.91865 1.5867C4.35399 2.78598 2.61731 4.4913 1.39216 7.01375C0.51589 8.8178 0.277417 9.87221 0.272529 11.9621C0.267759 13.9934 0.514102 15.1902 1.26815 16.7994C2.47793 19.381 4.17085 21.1077 6.70307 22.3432C10.4259 24.1594 14.7618 23.8409 18.2238 21.4971L18.8941 21.0432L19.3911 21.5498C19.8422 22.0094 19.8768 22.0866 19.7642 22.3826C19.6055 22.8003 19.6058 23.42 19.7651 23.8482C19.9119 24.2426 25.7379 30.135 26.2487 30.4058C26.7898 30.6925 27.6519 30.6421 28.2551 30.2887C28.8553 29.9369 29.7796 28.9849 30.0744 28.4148C30.3298 27.921 30.3398 27.0212 30.0951 26.5594C29.8243 26.0485 23.9319 20.2225 23.5375 20.0758C23.1093 19.9165 22.4896 19.9162 22.0719 20.0749C21.7759 20.1875 21.6987 20.1529 21.2391 19.7018L20.7326 19.2047L21.1864 18.5345C23.5302 15.0725 23.8487 10.7366 22.0325 7.01375C20.7974 4.48224 19.0702 2.7886 16.4906 1.57979C15.0561 0.90753 13.7849 0.622674 12.0091 0.575694C11.1893 0.553993 10.3577 0.561982 10.1609 0.593461ZM13.6144 2.84333C19.6167 4.08316 22.8017 10.6464 20.0963 16.2007C18.9993 18.4528 16.8834 20.224 14.3342 21.0236C13.1624 21.3912 11.1812 21.4773 9.89408 21.2164C5.47052 20.3201 2.35094 16.5174 2.35094 12.0217C2.35094 7.60087 5.4177 3.76897 9.68398 2.85907C10.7843 2.62442 12.5209 2.6175 13.6144 2.84333ZM5.8088 12.0217V13.1544H11.711H17.6132V12.0217V10.8889H11.711H5.8088V12.0217Z"
                        fill="#195DBD"/>
                </svg>
              </button>
              <button class="btn btn-zoomIn">
                <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.7187 0.584714C10.6696 0.596499 10.3883 0.637748 10.0937 0.676438C6.78358 1.11101 3.7046 3.14597 1.89874 6.09258C1.13685 7.33577 0.601324 8.82068 0.353114 10.3782C0.305317 10.678 0.272461 11.3571 0.272461 12.0448C0.272461 12.7326 0.305317 13.4117 0.353114 13.7115C0.75269 16.2188 1.861 18.4129 3.61198 20.1632C5.33677 21.8873 7.46208 22.972 9.94489 23.3954C10.7981 23.5409 12.6441 23.5412 13.4997 23.3959C15.3469 23.0824 17.1513 22.3332 18.4859 21.3255C18.6558 21.1972 18.8198 21.0923 18.8503 21.0923C18.8807 21.0923 19.1267 21.3145 19.3969 21.5861L19.8881 22.0799L19.7825 22.2855C19.7031 22.4399 19.6768 22.6319 19.6768 23.0574C19.6768 24.0442 19.5783 23.9178 23.0223 27.3475C26.405 30.7163 26.2381 30.5861 27.1767 30.5861C27.9761 30.5861 28.2256 30.4503 29.1808 29.4951C30.136 28.5399 30.2719 28.2904 30.2719 27.491C30.2719 26.5543 30.3947 26.7127 27.0927 23.3922C25.502 21.7926 24.0666 20.3976 23.9029 20.2922C23.7393 20.1868 23.478 20.0657 23.3224 20.0231C22.964 19.9252 22.2366 19.9675 21.9669 20.1021L21.7656 20.2024L21.2718 19.7112C21.0002 19.441 20.778 19.195 20.778 19.1645C20.778 19.1341 20.8829 18.9701 21.0112 18.8002C22.0189 17.4656 22.7682 15.6612 23.0817 13.814C23.2269 12.9583 23.2267 11.1124 23.0811 10.2592C22.6577 7.77636 21.573 5.65104 19.8489 3.92625C18.1374 2.21409 16.0229 1.12518 13.5758 0.695962C13.1205 0.616142 10.9416 0.531263 10.7187 0.584714ZM13.0103 2.76604C16.867 3.25871 20.0579 6.2321 20.8999 10.1179C21.0971 11.0278 21.1272 12.6219 20.9653 13.5719C20.631 15.5332 19.7467 17.2428 18.3376 18.6519C16.5427 20.4468 14.2668 21.3899 11.7306 21.3899C7.02905 21.3899 3.13496 18.011 2.44432 13.3321C2.35438 12.7228 2.35385 11.3699 2.44331 10.765C2.68057 9.16068 3.27568 7.71773 4.22465 6.44585C5.50879 4.72493 7.34411 3.49466 9.40919 2.97056C10.6187 2.6636 11.7192 2.6011 13.0103 2.76604ZM10.5401 8.53301V10.8544H8.21873H5.89735V12.0448V13.2353H8.21873H10.5401V15.5567V17.8781H11.7306H12.921V15.5567V13.2353H15.2424H17.5638V12.0448V10.8544H15.2424H12.921V8.53301V6.21163H11.7306H10.5401V8.53301Z"
                        fill="#195DBD"/>
                </svg>
              </button>
            </div>
<!--            <Loader style="position: absolute; left: 50%; top: 0;"  :class="{ 'visibility-non ': !mapLoader2024 }"/>-->
          </div>

          <div class="col-lg-3 px-00 0px 8px rgb(0 0 0 / 10%) result-col">
            <div class="map-stat">
              <div class="title title-light-blue py-4" id="mapTitle"></div>
              <dl>
                <dt id="mapFinalist"></dt>

                <dd>{{ $t('for-winners.finalist') }}</dd>
              </dl>
<!--              <dl v-if="year !== '2023'">-->
<!--                <dt id="mapFiveFinalist"></dt>-->

<!--                <dd>5 {{ $t('for-winners.class') }}</dd>-->
<!--              </dl>-->
<!--              <dl v-if="year !== '2023'">-->
<!--                <dt id="mapSixFinalist"></dt>-->

<!--                <dd>6 {{ $t('for-winners.class') }}</dd>-->
<!--              </dl>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="map-container-wrap" v-show="mapTab=='winners'">
      <div class="container-fluid map-container overflow-hidden">
        <div style="padding-top: 2rem" class="row position-relative">

          <div class="container-map-title">
            <h2 class="title">{{ $t('for-winners.winners-geography') }}</h2>
            <div class="col-md-5 "   style="max-width: 250px;margin: auto">
              <span>{{ $t('for-winners.olimpiad-year') }}</span>
              <el-select
                  :value="year"
                  @input="setYear">
                <el-option
                    key="1"
                    :label="2021"
                    :value="'2021'"
                    @click="setYear('2021')">
                </el-option>
                <el-option
                    key="2"
                    :label="2022"
                    :value="'2022'"
                    @click="setYear('2022')">
                </el-option>
                <el-option
                    key="3"
                    :label="2023"
                    :value="'2023'"
                    @click="setYear('2023')">
                </el-option>
                <el-option
                    key="4"
                    :label="2024"
                    :value="'2024'"
                    @click="setYear('2024')"
                />
                <el-option
                    key="5"
                    :label="2025"
                    :value="'2025'"
                    @click="setYear('2025')"
                />
                <el-option
                    key="6"
                    :label="2026"
                    :value="'2026'"
                    @click="setYear('2026')">
                </el-option>
              </el-select>
            </div>
            <div class="container-map-buttons">
              <el-button
                  v-bind:class="{'btn-active':mapTab=='finalists'}"
                  @click="mapTab='finalists'"
                  type="primary"
                  class="container-map-button"
              >
                {{ $t('for-winners.finalist') }}
              </el-button>
              <el-button
                  v-bind:class="{'btn-active':mapTab=='winners'}"
                  @click="mapTab='winners'"
                  type="primary"
                  class="container-map-button"
              >
                {{ $t('for-winners.winners') }}
              </el-button>
            </div>
          </div>
          <div class="col-lg-9">

            <div id="canvas">
              <div id="paper-winners" style="padding-top: 50px"></div>
            </div>

            <div class="mapZooming">
              <button class="btn btn-zoomOut">
                <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.1609 0.593461C9.1944 0.747872 7.79743 1.17593 6.91865 1.5867C4.35399 2.78598 2.61731 4.4913 1.39216 7.01375C0.51589 8.8178 0.277417 9.87221 0.272529 11.9621C0.267759 13.9934 0.514102 15.1902 1.26815 16.7994C2.47793 19.381 4.17085 21.1077 6.70307 22.3432C10.4259 24.1594 14.7618 23.8409 18.2238 21.4971L18.8941 21.0432L19.3911 21.5498C19.8422 22.0094 19.8768 22.0866 19.7642 22.3826C19.6055 22.8003 19.6058 23.42 19.7651 23.8482C19.9119 24.2426 25.7379 30.135 26.2487 30.4058C26.7898 30.6925 27.6519 30.6421 28.2551 30.2887C28.8553 29.9369 29.7796 28.9849 30.0744 28.4148C30.3298 27.921 30.3398 27.0212 30.0951 26.5594C29.8243 26.0485 23.9319 20.2225 23.5375 20.0758C23.1093 19.9165 22.4896 19.9162 22.0719 20.0749C21.7759 20.1875 21.6987 20.1529 21.2391 19.7018L20.7326 19.2047L21.1864 18.5345C23.5302 15.0725 23.8487 10.7366 22.0325 7.01375C20.7974 4.48224 19.0702 2.7886 16.4906 1.57979C15.0561 0.90753 13.7849 0.622674 12.0091 0.575694C11.1893 0.553993 10.3577 0.561982 10.1609 0.593461ZM13.6144 2.84333C19.6167 4.08316 22.8017 10.6464 20.0963 16.2007C18.9993 18.4528 16.8834 20.224 14.3342 21.0236C13.1624 21.3912 11.1812 21.4773 9.89408 21.2164C5.47052 20.3201 2.35094 16.5174 2.35094 12.0217C2.35094 7.60087 5.4177 3.76897 9.68398 2.85907C10.7843 2.62442 12.5209 2.6175 13.6144 2.84333ZM5.8088 12.0217V13.1544H11.711H17.6132V12.0217V10.8889H11.711H5.8088V12.0217Z"
                        fill="#195DBD"/>
                </svg>
              </button>
              <button class="btn btn-zoomIn">
                <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.7187 0.584714C10.6696 0.596499 10.3883 0.637748 10.0937 0.676438C6.78358 1.11101 3.7046 3.14597 1.89874 6.09258C1.13685 7.33577 0.601324 8.82068 0.353114 10.3782C0.305317 10.678 0.272461 11.3571 0.272461 12.0448C0.272461 12.7326 0.305317 13.4117 0.353114 13.7115C0.75269 16.2188 1.861 18.4129 3.61198 20.1632C5.33677 21.8873 7.46208 22.972 9.94489 23.3954C10.7981 23.5409 12.6441 23.5412 13.4997 23.3959C15.3469 23.0824 17.1513 22.3332 18.4859 21.3255C18.6558 21.1972 18.8198 21.0923 18.8503 21.0923C18.8807 21.0923 19.1267 21.3145 19.3969 21.5861L19.8881 22.0799L19.7825 22.2855C19.7031 22.4399 19.6768 22.6319 19.6768 23.0574C19.6768 24.0442 19.5783 23.9178 23.0223 27.3475C26.405 30.7163 26.2381 30.5861 27.1767 30.5861C27.9761 30.5861 28.2256 30.4503 29.1808 29.4951C30.136 28.5399 30.2719 28.2904 30.2719 27.491C30.2719 26.5543 30.3947 26.7127 27.0927 23.3922C25.502 21.7926 24.0666 20.3976 23.9029 20.2922C23.7393 20.1868 23.478 20.0657 23.3224 20.0231C22.964 19.9252 22.2366 19.9675 21.9669 20.1021L21.7656 20.2024L21.2718 19.7112C21.0002 19.441 20.778 19.195 20.778 19.1645C20.778 19.1341 20.8829 18.9701 21.0112 18.8002C22.0189 17.4656 22.7682 15.6612 23.0817 13.814C23.2269 12.9583 23.2267 11.1124 23.0811 10.2592C22.6577 7.77636 21.573 5.65104 19.8489 3.92625C18.1374 2.21409 16.0229 1.12518 13.5758 0.695962C13.1205 0.616142 10.9416 0.531263 10.7187 0.584714ZM13.0103 2.76604C16.867 3.25871 20.0579 6.2321 20.8999 10.1179C21.0971 11.0278 21.1272 12.6219 20.9653 13.5719C20.631 15.5332 19.7467 17.2428 18.3376 18.6519C16.5427 20.4468 14.2668 21.3899 11.7306 21.3899C7.02905 21.3899 3.13496 18.011 2.44432 13.3321C2.35438 12.7228 2.35385 11.3699 2.44331 10.765C2.68057 9.16068 3.27568 7.71773 4.22465 6.44585C5.50879 4.72493 7.34411 3.49466 9.40919 2.97056C10.6187 2.6636 11.7192 2.6011 13.0103 2.76604ZM10.5401 8.53301V10.8544H8.21873H5.89735V12.0448V13.2353H8.21873H10.5401V15.5567V17.8781H11.7306H12.921V15.5567V13.2353H15.2424H17.5638V12.0448V10.8544H15.2424H12.921V8.53301V6.21163H11.7306H10.5401V8.53301Z"
                        fill="#195DBD"/>
                </svg>
              </button>
            </div>
          </div>

          <div class="col-lg-3 px-00 0px 8px rgb(0 0 0 / 10%) result-col">
            <div class="map-stat">
              <div class="title title-light-blue py-4" id="mapTitleWinners"></div>
              <dl>
                <dt id="mapWinners"></dt>
                <dd>{{ $t('for-winners.winners') }}</dd>
              </dl>
              <dl v-if="year <= '2022'">
                <dt id="mapFive"></dt>
                <dd>5 {{ $t('for-winners.class') }}</dd>
              </dl>
              <dl v-if="year <= '2022'">
                <dt id="mapSix"></dt>
                <dd>6 {{ $t('for-winners.class') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="result mb-5 pt-3">
      <div class="container">
        <h1 class="title text-center">{{ $t('for-winners.first-stage-results') }}</h1>
        <div class="winners-subtitle pb-5 text-center">{{ $t('for-winners.table-title-finalist') }}</div>
        <div>
          <b-tabs content-class="" fill class="winner-nav">
            <b-tab :title="$t('for-winners.first-stage-results')" active>
              <div class="container">
                <div class="row">
                  <div class="col-12 border-bottom order-lg-1 order-3 mobile-pagination" v-if="meta && meta.total > 10">
                    <ul class="pagination py-3">
                      <li v-for="(link, index) in meta.links" :key="link.label">
                        <a @click.prevent="link.url ? goToPage(meta.current_page - 1) : null" v-if="index === 0">
                          <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.240234 5.00879C0.240234 5.21875 0.323242 5.39941 0.484375 5.56055L4.23437 9.21777C4.36133 9.34473 4.51758 9.41309 4.70312 9.41309C5.08398 9.41309 5.38672 9.11035 5.38672 8.73438C5.38672 8.54883 5.31348 8.37305 5.17676 8.23633L1.85645 5.01367L5.17676 1.78613C5.30859 1.64941 5.38672 1.47852 5.38672 1.28809C5.38672 0.912109 5.08398 0.609375 4.70312 0.609375C4.51758 0.609375 4.36133 0.677734 4.22949 0.804688L0.484375 4.46191C0.318359 4.63281 0.240234 4.80371 0.240234 5.00879Z"
                                fill="#69788C"/>
                          </svg>
                        </a>
                        <a @click.prevent="link.url ? goToPage(meta.current_page + 1) : null"
                           v-else-if="index === meta.links.length - 1">
                          <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.38672 5.01367C5.38672 4.80371 5.30371 4.62305 5.14258 4.46191L1.39258 0.804688C1.26562 0.677734 1.10937 0.609375 0.923828 0.609375C0.542969 0.609375 0.240234 0.912109 0.240234 1.28809C0.240234 1.47363 0.313477 1.64941 0.450195 1.78613L3.77051 5.00879L0.450195 8.23633C0.318359 8.37305 0.240234 8.54395 0.240234 8.73438C0.240234 9.11035 0.542969 9.41309 0.923828 9.41309C1.10937 9.41309 1.26562 9.34473 1.39746 9.21777L5.14258 5.56055C5.30859 5.38965 5.38672 5.21875 5.38672 5.01367Z"
                                fill="#69788C"/>
                          </svg>
                        </a>
                        <a @click.prevent="link.url ? goToPage(link.label) : null" :class="{active: link.active}" v-else>
                          {{ link.label }}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="col-12 order-lg-1 order-2">
                    <div style="margin-top: 1rem;margin-bottom: 1rem;" class="form-control-block">
                      <div class="form-control-item">
                        <input type="text" class="form-control search-input"
                               :placeholder="$t('for-winners.search-results')" v-model="search"
                               @keypress.enter.prevent="handleSearch">
                      </div>
                      <div class="form-group form-control-item">
                        <select id="regions" class="form-control" v-model="filters.region" @change="setRegion">
                          <option value="">{{ $t('for-winners.filter-region') }}</option>
                          <option v-for="(region, index) in regions" :key="index" :value="region.id">{{
                              region.name
                            }}
                          </option>
                        </select>
                      </div>
                      <div class="btns-block">
                        <div class="btn btn-filter-modal" @click="setFilters">{{ $t('references.apply-btn') }}</div>
                        <div class="btn btn-filter-modal" @click="resetFilters">{{ $t('references.reset-btn') }}</div>
                      </div>
                    </div>


                  </div>
                  <div class="col-12 order-lg-1 order-2">
                    <div class="table-response-helper">
                      <div class="table-response">
                        <table class="table table-striped mb-0" id="firstResult">
                          <thead>
                          <tr>
                            <th>{{ $t('for-winners.table-name-finalist') }}</th>
                            <th>{{ $t('for-winners.table-area') }}</th>
<!--                            <th>{{ $t('for-winners.table-district') }}</th>-->
<!--                            <th>{{ $t('for-winners.table-city') }}</th>-->
<!--                            <th> {{ $t('for-winners.table-school') }}</th>-->
<!--                            <th>{{ $t('for-winners.table-class') }}</th>-->
<!--                            <th>{{ $t('references.test-language-label') }}</th>-->
                            <th>{{ $t('for-winners.table-name-final-score') }}</th>
                          </tr>
                          </thead>
                          <tbody v-if="fullWinners.length > 0">
                          <tr v-if="!newTypeData()" v-for="(winner, index) in fullWinners" :key="winner.fullname + index">
                            <td>{{ winner.fullname }}</td>
                            <td>{{ winner.region }}</td>
<!--                            <td>{{ winner.area }}</td>-->
<!--                            <td>{{ winner.location }}</td>-->
<!--                            <td class="table-row">{{ winner.school }}</td>-->
<!--                            <td>{{ winner.classroom }}</td>-->
<!--                            <td>-->
<!--                              {{-->
<!--                                winner.test_language == 'ru' ? $t('references.language-ru') : $t('references.language-kz')-->
<!--                              }}-->
<!--                            </td>-->

                            <th>{{ winner.total_score | round}}</th>

                          </tr>
                          <tr v-if="newTypeData()" v-for="(winner, index) in fullWinners" :key="winner.fullname + index">
                            <td>{{ winner.user.full_name }}</td>
                            <td>{{ winner.user.location.region }}</td>
<!--                            <td>{{ winner.user.location.city }}</td>-->
<!--                            <td>{{ winner.user.location.locality }}</td>-->
<!--                            <td class="table-row">{{ winner.user.school }}</td>-->
<!--                            <td>6</td>-->
<!--                            <td>-->
<!--                              {{-->
<!--                                winner.test_language == 'ru' ? $t('references.language-ru') : $t('references.language-kz')-->
<!--                              }}-->
<!--                            </td>-->

                            <th>{{ winner.results.result | round}}</th>

                          </tr>
                          </tbody>
                          <tbody v-else>
                          <tr>
                            <p class="emptyTable">По Вашему запросу ничего не найдено</p>
                          </tr>
                          </tbody>
                        </table>
                        <!-- чтобы не было логов в консоли -->
                        <table id="secondResult"></table>
                        <table id="winnerResult"></table>
                        <!-- -->
                      </div>
                    </div>

                  </div>
                </div>


              </div>
            </b-tab>
          </b-tabs>

          <h1 style="margin-top: 5rem" class="title text-center">
            {{ $t('for-winners.second-stage-results') }}
          </h1>
          <div class="winners-subtitle text-center">{{ $t('for-winners.table-title-winner') }}</div>

          <b-tabs style="margin-top: 5rem" content-class="" fill class="winner-nav">

            <!-- ВТОРОЙ ЭТАП -->

            <b-tab :title="$t('for-winners.second-stage-results')" lazy>
              <div class="container">
                <div class="row">
                  <div class="col-12 border-bottom order-lg-1 order-3 mobile-pagination"
                       v-if="metaWinners && metaWinners.total > 10">
                    <ul class="pagination py-3">
                      <li v-for="(link, index) in metaWinners.links" :key="link.label">
                        <a
                            @click.prevent="link.url ? goToPageWinners(metaWinners.current_page - 1) : null"
                            v-if="index === 0"
                        >
                          <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.240234 5.00879C0.240234 5.21875 0.323242 5.39941 0.484375 5.56055L4.23437 9.21777C4.36133 9.34473 4.51758 9.41309 4.70312 9.41309C5.08398 9.41309 5.38672 9.11035 5.38672 8.73438C5.38672 8.54883 5.31348 8.37305 5.17676 8.23633L1.85645 5.01367L5.17676 1.78613C5.30859 1.64941 5.38672 1.47852 5.38672 1.28809C5.38672 0.912109 5.08398 0.609375 4.70312 0.609375C4.51758 0.609375 4.36133 0.677734 4.22949 0.804688L0.484375 4.46191C0.318359 4.63281 0.240234 4.80371 0.240234 5.00879Z"
                                fill="#69788C"
                            />
                          </svg>
                        </a>
                        <a
                            @click.prevent="link.url ? goToPageWinners(metaWinners.current_page + 1) : null"
                            v-else-if="index === metaWinners.links.length - 1"
                        >
                          <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.38672 5.01367C5.38672 4.80371 5.30371 4.62305 5.14258 4.46191L1.39258 0.804688C1.26562 0.677734 1.10937 0.609375 0.923828 0.609375C0.542969 0.609375 0.240234 0.912109 0.240234 1.28809C0.240234 1.47363 0.313477 1.64941 0.450195 1.78613L3.77051 5.00879L0.450195 8.23633C0.318359 8.37305 0.240234 8.54395 0.240234 8.73438C0.240234 9.11035 0.542969 9.41309 0.923828 9.41309C1.10937 9.41309 1.26562 9.34473 1.39746 9.21777L5.14258 5.56055C5.30859 5.38965 5.38672 5.21875 5.38672 5.01367Z"
                                fill="#69788C"
                            />
                          </svg>
                        </a>
                        <a
                            @click.prevent="link.url ? goToPageWinners(link.label) : null" :class="{active: link.active}"
                            v-else
                        >
                          {{ link.label }}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="col-12 order-lg-1 order-2">
                    <div style="margin-top: 1rem;margin-bottom: 1rem;"  class="form-control-block">
                      <div class="form-control-item">
                        <input type="text" class="form-control search-input"
                               :placeholder="$t('for-winners.search-results')" v-model="searchWinners"
                               @keypress.enter.prevent="handleSearchWinners()">
                      </div>
                      <div class="form-group form-control-item">
                        <select id="regions" class="form-control" v-model="filtersWinners.region"
                                @change="setRegionWinner">
                          <option value="">{{ $t('for-winners.filter-region') }}</option>
                          <option v-for="(region, index) in regions" :key="index" :value="region.id">
                            {{ region.name }}
                          </option>
                        </select>
                      </div>
                      <div class="btns-block">
                        <div class="btn btn-filter-modal" @click="setFiltersWinners">
                          {{ $t('references.apply-btn') }}
                        </div>
                        <div class="btn btn-filter-modal" @click="resetFiltersWinners">
                          {{ $t('references.reset-btn') }}
                        </div>
                      </div>
                    </div>


                  </div>
                  <div class="col-12 order-lg-1 order-2">
                    <div class="table-response-helper">
                      <div class="table-response">
                        <table class="table table-striped mb-0" id="secondResult">
                          <thead>
                          <tr>
                            <th>{{ $t('for-winners.table-name-winner') }}</th>
                            <th>{{ $t('for-winners.table-area') }}</th>
<!--                            <th>{{ $t('for-winners.table-district') }}</th>-->
<!--                            <th>{{ $t('for-winners.table-city') }}</th>-->
<!--                            <th> {{ $t('for-winners.table-school') }}</th>-->
<!--                            <th>{{ $t('for-winners.table-class') }}</th>-->
<!--                            <th>{{ $t('references.test-language-label') }}</th>-->
                            <th v-if="newTypeData()">{{ $t('for-winners.table-name-final-score') }}</th>

                          </tr>
                          </thead>
                          <tbody v-if="fullWinnersSecond.length > 0">
                          <tr v-for="(winner, index) in fullWinnersSecond" :key="winner.fullname + index">
                            <td>{{ winner.fullname }}</td>
                            <td>{{ winner.region }}</td>
<!--                            <td>{{ winner.area }}</td>-->
<!--                            <td>{{ winner.location }}</td>-->
<!--                            <td class="table-row">{{ winner.school }}</td>-->
<!--                            <td>{{ winner.classroom }}</td>-->
<!--                            <td>-->
<!--                              {{-->
<!--                                winner.test_language == 'ru' ? $t('references.language-ru') : $t('references.language-kz')-->
<!--                              }}-->
<!--                            </td>-->
                            <th v-if="newTypeData()">{{winner.result | round}}</th>
                          </tr>
                          </tbody>
                          <tbody v-else>
                          <tr>
                            <p class="emptyTable">По Вашему запросу ничего не найдено</p>
                          </tr>
                          </tbody>
                        </table>
                        <!-- чтобы не было логов в консоли -->
                        <table id="secondResult"></table>
                        <table id="winnerResult"></table>
                        <!-- -->
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </b-tab>
          </b-tabs>

        </div>
      </div>

    </section>
    <div class="container container-winners-text ">
      <p>
        {{ $t('for-winners.finalist-text') }}
      </p>
    </div>
    <section class="winner-school ">
      <div class="container-sm">
        <h1 class="title text-center py-5">{{ $t('for-winners.our-winners') }}</h1>

        <div class="winner-list justify-content-md-between justify-content-center">
          <div class="card">
            <span class="card-image text-center"> <img src="/images/ws-1.png" alt="" class="img-fluid"></span>
            <div class="winner-name">{{ $t('for-winners.daryn') }}</div>
          </div>
          <div class="card">
            <span class="card-image text-center"><img src="/images/ws-2.png" alt="" class="img-fluid"></span>
            <div class="winner-name">{{ $t('for-winners.bilim') }}</div>
          </div>
          <div class="card">
            <span class="card-image text-center"><img src="/images/ws-3.png" alt="" class=""></span>
            <div class="winner-name">{{ $t('for-winners.rfmsh') }}</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import '../../../public/css/historyMap.css';

import pathsKz from '@/plugins/paths/kzNew.js';
import pathsRu from '@/plugins/paths/ruNew.js';
import * as API from '@/api'
import Loader from '@/components/Loader'
import {Carousel, Slide} from 'vue-carousel';

export default {
  components: {
    Loader,
    Carousel,
    Slide,
  },
  data() {
    return {
      manualNavigation: 0,
      dataMap: {},
      dataMapSecond: {},
      AreaWinners1: {},
      AreaWinners2: {},
      AreaWinners3: {},
      mapTab: 'finalists',
      yearLabel: '',
      pathFile: {},
      isFilterFormVisible: false,
      scrollVal: 0,
      scrollValMax: '',
      year: '2021',
      winners: [],
      fullWinners: [],
      fullWinnersSecond: [],
      meta: {},
      pages: 0,
      metaWinners: {},
      pagesWinners: 0,
      tablePage: 1,
      search: null,
      searchWinners: null,
      debounceTimeout: null,
      filterRegion: null,
      filterArea: null,
      filterLocation: null,
      filterSchool: null,
      filterClassroom: null,
      disabledDistricts: true,
      disabledLocalities: true,
      disabledSchools: true,
      disabledDistrictsWinners: true,
      disabledLocalitiesWinners: true,
      disabledSchoolsWinners: true,
      areaWinners: [],
      regions: [],
      districts: [],
      localities: [],
      schools: [],
      districtsWinners: [],
      localitiesWinners: [],
      schoolsWinners: [],
      filters: {
        region: '',
        city: '',
        locality: '',
        school: '',
        class: '6'
      },
      filtersWinners: {
        region: '',
        city: '',
        locality: '',
        school: '',
        class: '6'
      },
      apiWinners: 'winners/2021',
      apiAreaStatic: 'winners/area/statistic/2021',
      mapLoader: true,
      mapLoader2024: true
    }
  },
  filters :{
    round:function (value){
      return Math.round((value)*100)/100
    }
  },
  watch: {
    'year'() {
      if (this.year == '2022' && this.mapTab == 'winners') {
        this.mapTab = 'finalists'
      }
    },
    'mapTab'() {
      if (this.year == 2021) {
        $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].finalists : '0')
        $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].class_five_finalists : '0')
        $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].class_six_finalists : '0')
        $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].region_id : '');
        $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].region_id : '')
        $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].winners : '0')
        $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].class_five : '0')
        $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].class_six : '0')
      } else if (this.year == 2022) {
        $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].finalists : '0')
        $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].class_five_finalists : '0')
        $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].class_six_finalists : '0')
        $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].region_id : '');
        $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].region_id : '')
        $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].winners : '0')
        $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].class_five : '0')
        $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].class_six : '0')
      } else if (this.year == 2023) {
        $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].finalists : '0')
        $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].class_five_finalists : '0')
        $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].class_six_finalists : '0')
        $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].region_id : '');
        $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].region_id : '')
        $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].winners : '0')
        $("#mapFive").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].class_five : '0')
        $("#mapSix").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].class_six : '0')
      }
    }
  },

  methods: {
    newTypeData() {
      return this.year >= 2023;
    },
    async getDataMapNew() {
      this.mapLoader2024 = true
      let res = await this.$http.get(`${API.Api}/api/winners/get/regions/${this.year}`)
      this.dataMap = res.body.data.filter(({ stage }) => stage === 'first')

      console.log('this.dataMap', this.dataMap)

      this.dataMapSecond = res.body.data.filter(({ stage }) => stage === 'second')
      const totalCount = this.dataMap.reduce((acc, item) => acc + item.count, 0)
      const totalCountSecond = this.dataMapSecond.reduce((acc, item) => acc + item.count, 0)
      $("#mapFinalist").text(totalCount ?? 0)
      $("#mapWinners").text(totalCountSecond ?? 0)

      this.mapLoader2024 = false
    },
    checkLanguage() {
      switch (this.$i18n.locale) {
        case 'ru':
          this.pathFile = pathsRu;
          break;
        case 'kz':
          this.pathFile = pathsKz;
          break;
        case 'en':
          this.pathFile = pathsRu;
          break;
        default:
          this.pathFile = pathsRu;
      }
    },

    setYear(year) {
      this.yearLabel = this.$t('for-winners.title2').replace('year', year)
      this.year = year;
      // this.getWinners();
      this.resetFilters();
      this.getDataMapNew()
      this.getfullWinnersSecond();
      this.handleSearch();
      if (this.year == 2021 || this.year == 2022) {
        this.getAreaWinners();
        this.getAreaWinners2();
      }
      // this.getAreaWinners3();
    },
    historyMapStartWinners() {
      let paths = this.pathFile;
      var tekser = "";
      var R = Raphael("paper-winners", 1400, 700);
      R.setViewBox(0, 0, 1100, 700, true)
      R.canvas.style.background = '#fff';
      var attr = {
        fill: "#9EA8CB",
        stroke: "#fff",
        "stroke-width": 2,
        "background": "white",
        "stroke-linejoin": "round",
        "transform": " s3.3,3.3,0,10",
        "transform": "scale(.25)",
        "class": 'mapPath'
      };

      var regions = {};

      var current = null;
      var i = 0;
      for (var state in paths) {
        i++;
        var region = {};

        region.map = R.path(paths[state].pathMap).attr(attr);
        region.text = R.path(paths[state].pathText).attr({
          fill: '#fff',
          stroke: 'transparent'
        });

        region.text.node.setAttribute('class', 'pathText');
        region.map.node.setAttribute('class', 'pathMap');

        region.name = paths[state].name;
        regions[i] = region;

        if (region.name == 'Алматы' || region.name == 'Шымкент' || region.name == 'Нур-Султан' || region.name == 'Алматы қ.' || region.name == 'Шымкент қ.' || region.name == 'Нұр-Cұлтан қ.') {
          region.text.node.setAttribute('class', 'hiddenCity')
          region.map.node.setAttribute('class', 'hiddenMap')
        }
      }
      if (this.year == 2021) {
        $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].region_id : '');
        $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].region_id : '')
        $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].winners : '0')
        $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].class_five : '0')
        $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].class_six : '0')
      } else if (this.year == 2022) {
        $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].region_id : '');
        $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].region_id : '')
        $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].winners : '0')
        $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].class_five : '0')
        $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].class_six : '0')
      } else if (this.year == 2023) {
        $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].region_id : '');
        $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].region_id : '')
        $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].winners : '0')
        $("#mapFive").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].class_five : '0')
        $("#mapSix").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].class_six : '0')
      } else if (this.year >= 2024) {
        $("#mapWinners").text(this.metaWinners && this.metaWinners.total ? this.metaWinners.total : '0')
      }
      for (var regionId in regions) {
        regions[regionId].color = Raphael.getColor();

        ((region, regionId) => {
          region.map[0].style.cursor = "pointer";
          region.map[0].onmouseenter = () => {
            $("#mapTitleWinners").text(region.name);
            current = regionId;
            regions[current].map[0].classList.add('activeRegion');
            if (this.year == 2021) {
              if (region.name === 'Акмолинская область' || region.name === 'Ақмола облысы' || region.name === 'Нур-Султан' || region.name === 'Нұр-Cұлтан қ.') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[0].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[0].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[0].class_six : '0')
              }
              if (region.name === 'Актюбинская область' || region.name === 'Ақтөбе облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[1].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[1].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[1].class_six : '0')
              }
              if (region.name === 'Алматинская область' || region.name === 'Алматы облысы' || region.name === 'Алматы' || region.name === 'Алматы қ.') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[2].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[2].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[2].class_six : '0')
              }
              if (region.name === 'Атырауская область' || region.name === 'Атырау облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[3].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[3].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[3].class_six : '0')
              }
              if (region.name === 'Восточно-Казахстанская область' || region.name === 'Шығыс Қазақстан облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[13].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[13].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[13].class_six : '0')
              }
              if (region.name === 'Жамбылская область' || region.name === 'Жамбыл облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[5].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[5].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[5].class_six : '0')
              }
              if (region.name === 'Западно-Казахстанская область' || region.name === 'Батыс Қазақстан облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[4].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[4].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[4].class_six : '0')
              }
              if (region.name === 'Карагандинская область' || region.name === 'Қарағанды облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[6].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[6].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[6].class_six : '0')
              }
              if (region.name === 'Костанайская область' || region.name === 'Қостанай облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[7].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[7].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[7].class_six : '0')
              }
              if (region.name === 'Кызылординская область' || region.name === 'Қызылорда облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[8].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[8].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[8].class_six : '0')
              }
              if (region.name === 'Мангистауская область' || region.name === 'Маңғыстау облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[9].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[9].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[9].class_six : '0')
              }
              if (region.name === 'Павлодарская область' || region.name === 'Павлодар облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[10].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[10].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[10].class_six : '0')
              }
              if (region.name === 'Северо-Казахстанская область' || region.name === 'Солтүстік Қазақстан облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[11].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[11].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[11].class_six : '0')
              }
              if (region.name === 'Туркестанская область' || region.name === 'Түркістан облысы' || region.name === 'Шымкент' || region.name === 'Шымкент қ.') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[12].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[12].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[12].class_six : '0')
              }
            } else if (this.year == '2022') {
              if (region.name === 'Акмолинская область' || region.name === 'Ақмола облысы' || region.name === 'Нур-Султан' || region.name === 'Нұр-Cұлтан қ.') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[0].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[0].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[0].class_six : '0')
              }
              if (region.name === 'Актюбинская область' || region.name === 'Ақтөбе облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[1].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[1].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[1].class_six : '0')
              }
              if (region.name === 'Алматинская область' || region.name === 'Алматы облысы' || region.name === 'Алматы' || region.name === 'Алматы қ.') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[2].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[2].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[2].class_six : '0')
              }
              if (region.name === 'Атырауская область' || region.name === 'Атырау облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[3].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[3].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[3].class_six : '0')
              }
              if (region.name === 'Восточно-Казахстанская область' || region.name === 'Шығыс Қазақстан облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[13].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[13].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[13].class_six : '0')
              }
              if (region.name === 'Жамбылская область' || region.name === 'Жамбыл облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[5].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[5].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[5].class_six : '0')
              }
              if (region.name === 'Западно-Казахстанская область' || region.name === 'Батыс Қазақстан облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[4].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[4].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[4].class_six : '0')
              }
              if (region.name === 'Карагандинская область' || region.name === 'Қарағанды облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[6].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[6].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[6].class_six : '0')
              }
              if (region.name === 'Костанайская область' || region.name === 'Қостанай облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[7].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[7].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[7].class_six : '0')
              }
              if (region.name === 'Кызылординская область' || region.name === 'Қызылорда облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[8].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[8].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[8].class_six : '0')
              }
              if (region.name === 'Мангистауская область' || region.name === 'Маңғыстау облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[9].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[9].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[9].class_six : '0')
              }
              if (region.name === 'Павлодарская область' || region.name === 'Павлодар облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[10].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[10].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[10].class_six : '0')
              }
              if (region.name === 'Северо-Казахстанская область' || region.name === 'Солтүстік Қазақстан облысы') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[11].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[11].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[11].class_six : '0')
              }
              if (region.name === 'Туркестанская область' || region.name === 'Түркістан облысы' || region.name === 'Шымкент' || region.name === 'Шымкент қ.') {
                $("#mapWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[12].winners : '0')
                $("#mapFive").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[12].class_five : '0')
                $("#mapSix").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[12].class_six : '0')
              }
            } else {
              if (region.name === 'Акмолинская область' || region.name === 'Ақмола облысы' || region.name === 'Нур-Султан' || region.name === 'Нұр-Cұлтан қ.') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 4)?.count ?? 0)
              } else if (region.name === 'Актюбинская область' || region.name === 'Ақтөбе облысы') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 5)?.count ?? 0)
              } else if (region.name === 'Алматинская область' || region.name === 'Алматы облысы' || region.name === 'Алматы' || region.name === 'Алматы қ.') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 6)?.count ?? 0)
              } else if (region.name === 'Атырауская область' || region.name === 'Атырау облысы') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 7)?.count ?? 0)
              } else if (region.name === 'Восточно-Казахстанская область' || region.name === 'Шығыс Қазақстан облысы') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 17)?.count ?? 0)
              } else if (region.name === 'Жамбылская область' || region.name === 'Жамбыл облысы') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 9)?.count ?? 0)
              } else if (region.name === 'Западно-Казахстанская область' || region.name === 'Батыс Қазақстан облысы') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 8)?.count ?? 0)
              } else if (region.name === 'Карагандинская область' || region.name === 'Қарағанды облысы') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 10)?.count ?? 0)
              } else if (region.name === 'Костанайская область' || region.name === 'Қостанай облысы') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 11)?.count ?? 0)
              } else if (region.name === 'Кызылординская область' || region.name === 'Қызылорда облысы') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 12)?.count ?? 0)
              } else if (region.name === 'Мангистауская область' || region.name === 'Маңғыстау облысы') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 13)?.count ?? 0)
              } else if (region.name === 'Павлодарская область' || region.name === 'Павлодар облысы') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 14)?.count ?? 0)
              } else if (region.name === 'Северо-Казахстанская область' || region.name === 'Солтүстік Қазақстан облысы') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 15)?.count ?? 0)
              } else if (region.name === 'Туркестанская область' || region.name === 'Түркістан облысы' || region.name === 'Шымкент' || region.name === 'Шымкент қ.') {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 16)?.count ?? 0)
              } else if (region.name === 'Область Ұлытау' || region.name === 'Ұлытау облысы')  {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 20)?.count ?? 0)
              } else if (region.name === 'Область Жетісу' || region.name === 'Жетісу облысы')  {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 19)?.count ?? 0)
              } else if (region.name === 'Область Абай' || region.name === 'Абай облысы')  {
                $("#mapWinners").text(this.dataMapSecond.find(item => item.stage === 'second' && item.region_id == 18)?.count ?? 0)
              }
            }
          };
          region.text[0].onmouseenter = function () {
            $("#mapTitleWinners").text(region.name);
            current = regionId;
            regions[current].map[0].classList.add('activeRegion');
          };


          region.map[0].onmouseleave = function () {
            regions[current].map[0].classList.remove('activeRegion');
          }
          region.text[0].onmouseleave = function () {
            regions[current].map[0].classList.remove('activeRegion');
          }

        })(regions[regionId], regionId);
      }
    },
    historyMapStart() {
      let paths = this.pathFile;
      var tekser = "";
      var R = Raphael("paper", 1400, 700);
      R.setViewBox(0, 0, 1100, 700, true)
      R.canvas.style.background = '#fff';
      var attr = {
        fill: "#9EA8CB",
        stroke: "#fff",
        "stroke-width": 2,
        "background": "white",
        "stroke-linejoin": "round",
        "transform": " s3.3,3.3,0,10",
        "transform": "scale(.25)",
        "class": 'mapPath'
      };

      var regions = {};

      var current = null;
      var i = 0;
      for (var state in paths) {
        i++;
        var region = {};

        region.map = R.path(paths[state].pathMap).attr(attr);
        region.text = R.path(paths[state].pathText).attr({
          fill: '#fff',
          stroke: 'transparent'
        });

        region.text.node.setAttribute('class', 'pathText');
        region.map.node.setAttribute('class', 'pathMap');

        region.name = paths[state].name;
        regions[i] = region;

        if (region.name == 'Алматы' || region.name == 'Шымкент' || region.name == 'Нур-Султан' || region.name == 'Алматы қ.' || region.name == 'Шымкент қ.' || region.name == 'Нұр-Cұлтан қ.') {
          region.text.node.setAttribute('class', 'hiddenCity')
          region.map.node.setAttribute('class', 'hiddenMap')
        }
      }
      if (this.year == 2021) {
        $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].region_id : '');
        $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].region_id : '')
        $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].finalists : '0')
        $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].class_five_finalists : '0')
        $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].class_six_finalists : '0')
      } else if (this.year == 2022) {
        $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].region_id : '');
        $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].region_id : '')
        $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].finalists : '0')
        $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].class_five_finalists : '0')
        $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].class_six_finalists : '0')
      } else {
        $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].region_id : '');
        $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].region_id : '')
        $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].finalists : '0')
        $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].class_five_finalists : '0')
        $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].class_six_finalists : '0')
      }
      for (var regionId in regions) {
        regions[regionId].color = Raphael.getColor();

        ((region, regionId) => {
          region.map[0].style.cursor = "pointer";
          region.map[0].onmouseenter = () => {
            $("#mapTitle").text(region.name);
            $("#mapTitleWinners").text(region.name)
            current = regionId;
            regions[current].map[0].classList.add('activeRegion');
            if (this.year == 2021) {
              if (region.name === 'Акмолинская область' || region.name === 'Ақмола облысы' || region.name === 'Нур-Султан' || region.name === 'Нұр-Cұлтан қ.') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[0].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[0].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[0].class_six_finalists : '0')
              } else if (region.name === 'Актюбинская область' || region.name === 'Ақтөбе облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[1].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[1].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[1].class_six_finalists : '0')
              } else if (region.name === 'Алматинская область' || region.name === 'Алматы облысы' || region.name === 'Алматы' || region.name === 'Алматы қ.') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[2].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[2].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[2].class_six_finalists : '0')
              } else if (region.name === 'Атырауская область' || region.name === 'Атырау облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[3].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[3].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[3].class_six_finalists : '0')
              } else if (region.name === 'Восточно-Казахстанская область' || region.name === 'Шығыс Қазақстан облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[13].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[13].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[13].class_six_finalists : '0')
              } else if (region.name === 'Жамбылская область' || region.name === 'Жамбыл облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[5].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[5].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[5].class_six_finalists : '0')
              } else if (region.name === 'Западно-Казахстанская область' || region.name === 'Батыс Қазақстан облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[4].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[4].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[4].class_six_finalists : '0')
              } else if (region.name === 'Карагандинская область' || region.name === 'Қарағанды облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[6].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[6].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[6].class_six_finalists : '0')
              } else if (region.name === 'Костанайская область' || region.name === 'Қостанай облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[7].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[7].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[7].class_six_finalists : '0')
              } else if (region.name === 'Кызылординская область' || region.name === 'Қызылорда облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[8].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[8].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[8].class_six_finalists : '0')
              } else if (region.name === 'Мангистауская область' || region.name === 'Маңғыстау облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[9].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[9].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[9].class_six_finalists : '0')
              } else if (region.name === 'Павлодарская область' || region.name === 'Павлодар облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[10].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[10].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[10].class_six_finalists : '0')
              } else if (region.name === 'Северо-Казахстанская область' || region.name === 'Солтүстік Қазақстан облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[11].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[11].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[11].class_six_finalists : '0')
              } else if (region.name === 'Туркестанская область' || region.name === 'Түркістан облысы' || region.name === 'Шымкент' || region.name === 'Шымкент қ.') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[12].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[12].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[12].class_six_finalists : '0')
              } else {
                if (this.year == 2021) {
                  $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].region_id : '');
                  $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].region_id : '')
                  $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].finalists : '0')
                  $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].class_five_finalists : '0')
                  $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].class_six_finalists : '0')
                } else if (this.year == 2022) {
                  $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].region_id : '');
                  $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].region_id : '')
                  $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].finalists : '0')
                  $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].class_five_finalists : '0')
                  $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].class_six_finalists : '0')
                } else {
                  $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].region_id : '');
                  $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].region_id : '')
                  $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].finalists : '0')
                  $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].class_five_finalists : '0')
                  $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].class_six_finalists : '0')
                }
              }
            } else if (this.year == '2022') {
              if (region.name === 'Акмолинская область' || region.name === 'Ақмола облысы' || region.name === 'Нур-Султан' || region.name === 'Нұр-Cұлтан қ.') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[0].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[0].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[0].class_six_finalists : '0')
              } else if (region.name === 'Актюбинская область' || region.name === 'Ақтөбе облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[1].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[1].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[1].class_six_finalists : '0')
              } else if (region.name === 'Алматинская область' || region.name === 'Алматы облысы' || region.name === 'Алматы' || region.name === 'Алматы қ.') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[2].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[2].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[2].class_six_finalists : '0')
              } else if (region.name === 'Атырауская область' || region.name === 'Атырау облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[3].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[3].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[3].class_six_finalists : '0')
              } else if (region.name === 'Восточно-Казахстанская область' || region.name === 'Шығыс Қазақстан облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[13].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[13].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[13].class_six_finalists : '0')
              } else if (region.name === 'Жамбылская область' || region.name === 'Жамбыл облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[5].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[5].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[5].class_six_finalists : '0')
              } else if (region.name === 'Западно-Казахстанская область' || region.name === 'Батыс Қазақстан облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[4].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[4].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[4].class_six_finalists : '0')
              } else if (region.name === 'Карагандинская область' || region.name === 'Қарағанды облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[6].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[6].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[6].class_six_finalists : '0')
              } else if (region.name === 'Костанайская область' || region.name === 'Қостанай облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[7].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[7].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[7].class_six_finalists : '0')
              } else if (region.name === 'Кызылординская область' || region.name === 'Қызылорда облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[8].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[8].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[8].class_six_finalists : '0')
              } else if (region.name === 'Мангистауская область' || region.name === 'Маңғыстау облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[9].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[9].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[9].class_six_finalists : '0')
              } else if (region.name === 'Павлодарская область' || region.name === 'Павлодар облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[10].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[10].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[10].class_six_finalists : '0')
              } else if (region.name === 'Северо-Казахстанская область' || region.name === 'Солтүстік Қазақстан облысы') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[11].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[11].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[11].class_six_finalists : '0')
              } else if (region.name === 'Туркестанская область' || region.name === 'Түркістан облысы' || region.name === 'Шымкент' || region.name === 'Шымкент қ.') {
                $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[12].finalists : '0')
                $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[12].class_five_finalists : '0')
                $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[12].class_six_finalists : '0')
              } else {
                if (this.year == 2021) {
                  $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].region_id : '');
                  $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].region_id : '')
                  $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].finalists : '0')
                  $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].class_five_finalists : '0')
                  $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_1") ? JSON.parse(localStorage.getItem("AREA_WINNERS_1"))[14].class_six_finalists : '0')
                } else if (this.year == 2022) {
                  $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].region_id : '');
                  $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].region_id : '')
                  $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].finalists : '0')
                  $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].class_five_finalists : '0')
                  $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_2") ? JSON.parse(localStorage.getItem("AREA_WINNERS_2"))[14].class_six_finalists : '0')
                } else {
                  $("#mapTitle").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].region_id : '');
                  $("#mapTitleWinners").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].region_id : '')
                  $("#mapFinalist").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].finalists : '0')
                  $("#mapFiveFinalist").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].class_five_finalists : '0')
                  $("#mapSixFinalist").text(localStorage.getItem("AREA_WINNERS_3") ? JSON.parse(localStorage.getItem("AREA_WINNERS_3"))[17].class_six_finalists : '0')
                }
              }

            }
            else if (this.year == '2024') {
              if (region.name === 'Акмолинская область' || region.name === 'Ақмола облысы' || region.name === 'Нур-Султан' || region.name === 'Нұр-Cұлтан қ.') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 32)[0].count ?? 0)
              } else if (region.name === 'Актюбинская область' || region.name === 'Ақтөбе облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 18)[0].count ?? 0)
              } else if (region.name === 'Алматинская область' || region.name === 'Алматы облысы' || region.name === 'Алматы' || region.name === 'Алматы қ.') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 19)[0].count ?? 0)
              } else if (region.name === 'Атырауская область' || region.name === 'Атырау облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 26)[0].count ?? 0)
              } else if (region.name === 'Восточно-Казахстанская область' || region.name === 'Шығыс Қазақстан облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 25)[0].count ?? 0)
              } else if (region.name === 'Жамбылская область' || region.name === 'Жамбыл облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 22)[0].count ?? 0)
              } else if (region.name === 'Западно-Казахстанская область' || region.name === 'Батыс Қазақстан облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 20)[0].count ?? 0)
              } else if (region.name === 'Карагандинская область' || region.name === 'Қарағанды облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 33)[0].count ?? 0)
              } else if (region.name === 'Костанайская область' || region.name === 'Қостанай облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 27)[0].count ?? 0)
              } else if (region.name === 'Кызылординская область' || region.name === 'Қызылорда облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 23)[0].count ?? 0)
              } else if (region.name === 'Мангистауская область' || region.name === 'Маңғыстау облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 31)[0].count ?? 0)
              } else if (region.name === 'Павлодарская область' || region.name === 'Павлодар облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 28)[0].count ?? 0)
              } else if (region.name === 'Северо-Казахстанская область' || region.name === 'Солтүстік Қазақстан облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 29)[0].count ?? 0)
              } else if (region.name === 'Туркестанская область' || region.name === 'Түркістан облысы' || region.name === 'Шымкент' || region.name === 'Шымкент қ.') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 24)[0].count ?? 0)
              } else if (region.name === 'Улытауская область' || region.name === 'Ұлытау облысы')  {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 34)[0].count ?? 0)
              } else if (region.name === 'Жетысуская область' || region.name === 'Жетісу облысы')  {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 21)[0].count ?? 0)
              } else if (region.name === 'Абайская область' || region.name === 'Абай облысы')  {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 30)[0].count ?? 0)
              }

            }
            else if (this.year == '2025') {
              if (region.name === 'Акмолинская область' || region.name === 'Ақмола облысы' || region.name === 'Нур-Султан' || region.name === 'Нұр-Cұлтан қ.') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 57)[0].count ?? 0)
              } else if (region.name === 'Актюбинская область' || region.name === 'Ақтөбе облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 59)[0].count ?? 0)
              } else if (region.name === 'Алматинская область' || region.name === 'Алматы облысы' || region.name === 'Алматы' || region.name === 'Алматы қ.') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 53)[0].count ?? 0)
              } else if (region.name === 'Атырауская область' || region.name === 'Атырау облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 64)[0].count ?? 0)
              } else if (region.name === 'Восточно-Казахстанская область' || region.name === 'Шығыс Қазақстан облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 58)[0].count ?? 0)
              } else if (region.name === 'Жамбылская область' || region.name === 'Жамбыл облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 56)[0].count ?? 0)
              } else if (region.name === 'Западно-Казахстанская область' || region.name === 'Батыс Қазақстан облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 65)[0].count ?? 0)
              } else if (region.name === 'Карагандинская область' || region.name === 'Қарағанды облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 62)[0].count ?? 0)
              } else if (region.name === 'Костанайская область' || region.name === 'Қостанай облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 52)[0].count ?? 0)
              } else if (region.name === 'Кызылординская область' || region.name === 'Қызылорда облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 67)[0].count ?? 0)
              } else if (region.name === 'Мангистауская область' || region.name === 'Маңғыстау облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 55)[0].count ?? 0)
              } else if (region.name === 'Павлодарская область' || region.name === 'Павлодар облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 60)[0].count ?? 0)
              } else if (region.name === 'Северо-Казахстанская область' || region.name === 'Солтүстік Қазақстан облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 54)[0].count ?? 0)
              } else if (region.name === 'Туркестанская область' || region.name === 'Түркістан облысы' || region.name === 'Шымкент' || region.name === 'Шымкент қ.') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 51)[0].count ?? 0)
              } else if (region.name === 'Область Ұлытау' || region.name === 'Ұлытау облысы')  {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 66)[0].count ?? 0)
              } else if (region.name === 'Область Жетісу' || region.name === 'Жетісу облысы')  {
                console.log('this.dataMap', this.dataMap)
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 63)[0].count ?? 0)
              } else if (region.name === 'Область Абай' || region.name === 'Абай облысы')  {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 61)[0].count ?? 0)
              }

            }
            else if (this.year == '2026') {
              if (region.name === 'Акмолинская область' || region.name === 'Ақмола облысы' || region.name === 'Нур-Султан' || region.name === 'Нұр-Cұлтан қ.') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 4)?.count ?? 0)
              } else if (region.name === 'Актюбинская область' || region.name === 'Ақтөбе облысы') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 5)?.count ?? 0)
              } else if (region.name === 'Алматинская область' || region.name === 'Алматы облысы' || region.name === 'Алматы' || region.name === 'Алматы қ.') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 6)?.count ?? 0)
              } else if (region.name === 'Атырауская область' || region.name === 'Атырау облысы') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 7)?.count ?? 0)
              } else if (region.name === 'Восточно-Казахстанская область' || region.name === 'Шығыс Қазақстан облысы') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 17)?.count ?? 0)
              } else if (region.name === 'Жамбылская область' || region.name === 'Жамбыл облысы') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 9)?.count ?? 0)
              } else if (region.name === 'Западно-Казахстанская область' || region.name === 'Батыс Қазақстан облысы') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 8)?.count ?? 0)
              } else if (region.name === 'Карагандинская область' || region.name === 'Қарағанды облысы') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 10)?.count ?? 0)
              } else if (region.name === 'Костанайская область' || region.name === 'Қостанай облысы') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 11)?.count ?? 0)
              } else if (region.name === 'Кызылординская область' || region.name === 'Қызылорда облысы') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 12)?.count ?? 0)
              } else if (region.name === 'Мангистауская область' || region.name === 'Маңғыстау облысы') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 13)?.count ?? 0)
              } else if (region.name === 'Павлодарская область' || region.name === 'Павлодар облысы') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 14)?.count ?? 0)
              } else if (region.name === 'Северо-Казахстанская область' || region.name === 'Солтүстік Қазақстан облысы') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 15)?.count ?? 0)
              } else if (region.name === 'Туркестанская область' || region.name === 'Түркістан облысы' || region.name === 'Шымкент' || region.name === 'Шымкент қ.') {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 16)?.count ?? 0)
              } else if (region.name === 'Область Ұлытау' || region.name === 'Ұлытау облысы')  {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 20)?.count ?? 0)
              } else if (region.name === 'Область Жетісу' || region.name === 'Жетісу облысы')  {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 19)?.count ?? 0)
              } else if (region.name === 'Область Абай' || region.name === 'Абай облысы')  {
                $("#mapFinalist").text(this.dataMap.find(item => item.region_id === 18)?.count ?? 0)
              }

            }
            else if (this.year == '2023') {
              if (region.name === 'Акмолинская область' || region.name === 'Ақмола облысы' || region.name === 'Нур-Султан' || region.name === 'Нұр-Cұлтан қ.') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 13)[0].count ?? 0)
              } else if (region.name === 'Актюбинская область' || region.name === 'Ақтөбе облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 12)[0].count ?? 0)
              } else if (region.name === 'Алматинская область' || region.name === 'Алматы облысы' || region.name === 'Алматы' || region.name === 'Алматы қ.') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 5)[0].count ?? 0)
              } else if (region.name === 'Атырауская область' || region.name === 'Атырау облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 3)[0].count ?? 0)
              } else if (region.name === 'Восточно-Казахстанская область' || region.name === 'Шығыс Қазақстан облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 6)[0].count ?? 0)
              } else if (region.name === 'Жамбылская область' || region.name === 'Жамбыл облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 1)[0].count ?? 0)
              } else if (region.name === 'Западно-Казахстанская область' || region.name === 'Батыс Қазақстан облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 16)[0].count ?? 0)
              } else if (region.name === 'Карагандинская область' || region.name === 'Қарағанды облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 15)[0].count ?? 0)
              } else if (region.name === 'Костанайская область' || region.name === 'Қостанай облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 9)[0].count ?? 0)
              } else if (region.name === 'Кызылординская область' || region.name === 'Қызылорда облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 8)[0].count ?? 0)
              } else if (region.name === 'Мангистауская область' || region.name === 'Маңғыстау облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 2)[0].count ?? 0)
              } else if (region.name === 'Павлодарская область' || region.name === 'Павлодар облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 10)[0].count ?? 0)
              } else if (region.name === 'Северо-Казахстанская область' || region.name === 'Солтүстік Қазақстан облысы') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 14)[0].count ?? 0)
              } else if (region.name === 'Туркестанская область' || region.name === 'Түркістан облысы' || region.name === 'Шымкент' || region.name === 'Шымкент қ.') {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 4)[0].count ?? 0)
              } else if (region.name === 'Улытауская область' || region.name === 'Ұлытау облысы')  {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 17)[0].count ?? 0)
              } else if (region.name === 'Жетысуская область' || region.name === 'Жетісу облысы')  {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 7)[0].count ?? 0)
              } else if (region.name === 'Абайская область' || region.name === 'Абай облысы')  {
                $("#mapFinalist").text(this.dataMap.filter(item => item.id == 11)[0].count ?? 0)
              }

            }


          };
          region.text[0].onmouseenter = function () {
            $("#mapTitle").text(region.name);
            current = regionId;
            regions[current].map[0].classList.add('activeRegion');
          };


          region.map[0].onmouseleave = function () {
            regions[current].map[0].classList.remove('activeRegion');
          }


          region.text[0].onmouseleave = function () {
            regions[current].map[0].classList.remove('activeRegion');
          }

        })(regions[regionId], regionId);
      }
    },

    async handleApiWinners(api) {
      this.apiWinners = api

      switch (api) {
        case 'winners/2021':
          this.apiAreaStatic = 'winners/area/statistic/2021'
          break;
        case 'winners-2021':
          this.apiAreaStatic = 'winners/area-statistic/2021'
          break;
      }
      this.apiWinners = api
      this.getWinners()
      this.getAreaWinners()
      this.resetFilters()
    },
    async handleSearch() {
      const params = {}
      for (const key in this.filters) {
        this.filters[key] && (params[key] = this.filters[key])
      }
      const response = await this.$http.get(`${API.Api}/api/winners/get/${this.year}?per_page=10`, {
        params: {
          search: this.search,
          ...params
        }
      })
      if (response.body) {
        this.fullWinners = response.body.data.data
        this.meta = {
          links: response.body.data.links,
          total: response.body.data.total,
          current_page: response.body.data.current_page
        }
      } else {
        this.fullWinners = []
        this.meta = {}
      }
    },
    async handleSearchWinners() {
      if (this.year == 2021) {
        const params = {}
        for (const key in this.filtersWinners) {
          this.filtersWinners[key] && (params[key] = this.filtersWinners[key])
        }
        const response = await this.$http.get(`${API.Api}/api/winners-2021?per_page=10`, {
          params: {
            search: this.searchWinners,
            ...params
          }
        })
        if (response.body) {
          this.fullWinnersSecond = response.body.data.data
          this.metaWinners = {
            links: response.body.data.links,
            total: response.body.data.total,
            current_page: response.body.data.current_page
          }
        } else {
          this.fullWinnersSecond = []
          this.metaWinners = {}
        }
      } else if (this.year == 2022) {
        const params = {}
        for (const key in this.filtersWinners) {
          this.filtersWinners[key] && (params[key] = this.filtersWinners[key])
        }
        const response = await this.$http.get(`${API.Api}/api/winners/second/2022?per_page=10`, {
          params: {
            search: this.searchWinners,
            ...params
          }
        })
        if (response.body) {
          this.fullWinnersSecond = response.body.data.data
          this.metaWinners = {
            links: response.body.data.links,
            total: response.body.data.total,
            current_page: response.body.data.current_page
          }
        } else {
          this.fullWinnersSecond = []
          this.metaWinners = {}
        }
      } else {
        const params = {}
        for (const key in this.filtersWinners) {
          this.filtersWinners[key] && (params[key] = this.filtersWinners[key])
        }
        const response = await this.$http.get(`${API.Api}/api/winners/second/${this.year}?per_page=10`, {
          params: {
            search: this.searchWinners,
            ...params
          }
        })
        if (response.body) {
          this.fullWinnersSecond = response.body.data.data.map(item => ({
            fullname: item.user.full_name,
            region: item.user.location.region,
            result: item.results.result,
          }))
          this.metaWinners = {
            links: response.body.data.links,
            total: response.body.data.total,
            current_page: response.body.data.current_page
          }
        } else {
          this.fullWinnersSecond = []
          this.metaWinners = {}
        }
      }
    },
    async goToPage(page) {
      const params = {}
      for (const key in this.filters) {
        this.filters[key] && (params[key] = this.filters[key])
      }
      const response = await this.$http.get(`${API.Api}/api/winners/get/${this.year}?per_page=10&page=${page}`, {
        params: {
          search: this.search,
          ...params
        }
      })
      if (response.body) {
        this.fullWinners = response.body.data.data
        this.meta = {
          links: response.body.data.links,
          total: response.body.data.total,
          current_page: response.body.data.current_page
        }
      } else {
        this.fullWinners = []
        this.meta = {}
      }
    },
    async goToPageWinners(page) {
      const params = {}
      let response
      for (const key in this.filtersWinners) {
        this.filtersWinners[key] && (params[key] = this.filtersWinners[key])
      }
      if (this.year == '2021') {
        response = await this.$http.get(`${API.Api}/api/winners-2021?per_page=10&page=${page}`, {
          params: {
            search: this.searchWinners,
            ...params
          }
        })
      } else {
        response = await this.$http.get(`${API.Api}/api/winners/second/${this.year}?per_page=10&page=${page}`, {
          params: {
            search: this.searchWinners,
            ...params
          }
        })
      }

      if (response.body) {
        this.fullWinnersSecond = this.fullWinnersSecond = this.year < 2024 ? response.body.data.data : response.body.data.data.map(item => ({
          fullname: item.user.full_name,
          region: item.user.location.region,
          result: item.results.result,
        }))
        this.metaWinners = {
          links: response.body.data.links,
          total: response.body.data.total,
          current_page: response.body.data.current_page
        }
      } else {
        this.fullWinnersSecond = []
        this.metaWinners = {}
      }

    },
    async getAreaWinners2() {
      this.mapLoader = true
      let areaWinners = []
      let res = await this.$http.get(`${API.Api}/api/winners/area/statistic/first/2022`)
      let res2 = await this.$http.get(`${API.Api}/api/winners/area/statistic/second/2022`)

      for (var i = 0; i < res.body.data.winners.length; i++) {
        areaWinners[i] = {
          'region_id': res.body.data.winners[i].region_id,
          'finalists': res.body.data.winners[i].count,
          'winners': res2.body.data.winners[i].count,
          'class_five': res2.body.data.class_five[i].count,
          'class_six': res2.body.data.class_six[i].count,
          'class_five_finalists': res.body.data.class_five[i].count,
          'class_six_finalists': res.body.data.class_six[i].count
        }
      }
      areaWinners[14] = {
        'region_id': this.$t('for-winners.total'),
        'finalists': 0,
        'winners': 0,
        'class_five': 0,
        'class_six': 0,
        'class_five_finalists': 0,
        'class_six_finalists': 0
      }
      for (var x = 0; x < res.body.data.winners.length; x++) {
        areaWinners[14].finalists += Number(areaWinners[x].finalists);
        areaWinners[14].winners += Number(areaWinners[x].winners);
        areaWinners[14].class_five += Number(areaWinners[x].class_five);
        areaWinners[14].class_six += Number(areaWinners[x].class_six);
        areaWinners[14].class_five_finalists += Number(areaWinners[x].class_five_finalists);
        areaWinners[14].class_six_finalists += Number(areaWinners[x].class_six_finalists);

      }
      localStorage.setItem("AREA_WINNERS_2", JSON.stringify(areaWinners))
      this.AreaWinners2 = localStorage.getItem('AREA_WINNERS_2');
      this.mapLoader = false
    },
    async getAreaWinners3() {
      this.mapLoader = true
      let areaWinners = []
      let res = await this.$http.get(`${API.Api}/api/winners/area/statistic/first/2023`)
      let res2 = await this.$http.get(`${API.Api}/api/winners/area/statistic/second/2023`)
      res.body.data.winners.sort( (a, b) => a.region_id - b.region_id)
      res2.body.data.winners.sort( (a, b) => a.region_id - b.region_id)

      for (var i = 0; i < res.body.data.winners.length; i++) {
        areaWinners[i] = {
          'region_id': res.body.data.winners[i].region_id,
          'finalists': res.body.data.winners[i].count,
          'winners': res2.body.data.winners[i].count,
        }
      }
      areaWinners[17] = {
        'region_id': this.$t('for-winners.total'),
        'finalists': 0,
        'winners': 0,
      }
      for (var x = 0; x < res.body.data.winners.length; x++) {
        areaWinners[17].finalists += Number(areaWinners[x].finalists);
        areaWinners[17].winners += Number(areaWinners[x].winners);
        // areaWinners[17].class_five += Number(areaWinners[x].class_five);
        // areaWinners[17].class_six += Number(areaWinners[x].class_six);
        // areaWinners[17].class_five_finalists += Number(areaWinners[x].class_five_finalists);
        // areaWinners[17].class_six_finalists += Number(areaWinners[x].class_six_finalists);

      }
      localStorage.setItem("AREA_WINNERS_3", JSON.stringify(areaWinners))
      this.AreaWinners3 = localStorage.getItem('AREA_WINNERS_3');
      this.mapLoader = false
    },
    getAreaWinners: async function () {
      this.mapLoader = true
      this.areaWinners = []
      let res = await this.$http.get(`${API.Api}/api/winners/area/statistic/2021`)
      for (var i = 0; i < res.body.data.winners.length; i++) {
        this.areaWinners[i] = {
          'region_id': res.body.data.class_five_finalists[i].region_id,
          'finalists': res.body.data.finalists[i].count,
          'winners': res.body.data.winners[i].count,
          'class_five': res.body.data.class_five[i].count,
          'class_six': res.body.data.class_six[i].count,
          'class_five_finalists': res.body.data.class_five_finalists[i].count,
          'class_six_finalists': res.body.data.class_six_finalists[i].count
        }
      }
      this.areaWinners[14] = {
        'region_id': this.$t('for-winners.total'),
        'finalists': 0,
        'winners': 0,
        'class_five': 0,
        'class_six': 0,
        'class_five_finalists': 0,
        'class_six_finalists': 0
      }
      for (var x = 0; x < res.body.data.winners.length; x++) {
        this.areaWinners[14].finalists += this.areaWinners[x].finalists;
        this.areaWinners[14].winners += this.areaWinners[x].winners;
        this.areaWinners[14].class_five += this.areaWinners[x].class_five;
        this.areaWinners[14].class_six += this.areaWinners[x].class_six;
        this.areaWinners[14].class_five_finalists += this.areaWinners[x].class_five_finalists;
        this.areaWinners[14].class_six_finalists += this.areaWinners[x].class_six_finalists;

      }

      localStorage.setItem("AREA_WINNERS_1", JSON.stringify(this.areaWinners))
      this.AreaWinners1 = localStorage.getItem('AREA_WINNERS_1');
      this.mapLoader = false
    },
    async getWinners() {
      const response = await this.$http.get(`${API.Api}/api/winners/${this.year}?per_page=10`)
      if (response.body) {
        this.fullWinners = response.body.data
        this.meta = {
          links: response.body.data.links,
          total: response.body.data.total,
          current_page: response.body.data.current_page
        }
      } else {
        this.fullWinners = []
        this.meta = {}
      }
    },
    async getfullWinnersSecond() {
      if (this.year == 2021) {
        const response = await this.$http.get(`${API.Api}/api/winners-2021?per_page=10`)
        if (response.body) {
          this.fullWinnersSecond = response.body.data.data
          this.metaWinners = {
            links: response.body.data.links,
            total: response.body.data.total,
            current_page: response.body.data.current_page
          }
        } else {
          this.fullWinnersSecond = []
          this.metaWinners = {}
        }
      } else {
        const response = await this.$http.get(`${API.Api}/api/winners/second/${this.year}?per_page=10`)
        console.log('[getfullWinnersSecond] year=', this.year, 'response.body=', response.body)
        if (response.body) {
          this.fullWinnersSecond = this.year < 2024 ? response.body.data : response.body.data.data.map(item => ({
            fullname: item.user.full_name,
            region: item.user.location.region,
            result: item.results.result,
          }))
          console.log('[getfullWinnersSecond] fullWinnersSecond.length=', this.fullWinnersSecond.length)
          this.metaWinners = {
            links: response.body.data.links,
            total: response.body.data.total,
            current_page: response.body.data.current_page
          }
          if (this.year >= 2024) {
            $("#mapWinners").text(response.body.data.total ?? 0)
          }
        } else {
          this.fullWinnersSecond = []
          this.metaWinners = {}
        }
      }
    },

    setRegion() {
      this.$http.get(`${API.Api}/api/references/districts/${this.filters.region}`)
          .then(res => {
            this.disabledDistricts = false,
                this.districts = res.body.data
            this.filters.city = ''
            this.filters.school = ''
            this.filters.locality = ''
          })
    },

    setDistrict() {
      this.$http.get(`${API.Api}/api/references/localities/${this.filters.city}`)
          .then(res => {
            this.disabledLocalities = false,
                this.localities = res.body.data
            this.filters.school = ''
            this.filters.locality = ''
          })
    },

    setLocality() {
      this.$http.get(`${API.Api}/api/references/schools/${this.filters.locality}`)
          .then(res => {
            this.disabledSchools = false,
                this.schools = res.body.data
            this.filters.school = ''

          })
    },
    setRegionWinner() {
      this.$http.get(`${API.Api}/api/references/districts/${this.filtersWinners.region}`)
          .then(res => {
            this.disabledDistrictsWinners = false,
                this.districtsWinners = res.body.data
            this.filtersWinners.city = ''
            this.filtersWinners.school = ''
            this.filtersWinners.locality = ''
          })
    },

    setDistrictWinner() {
      this.$http.get(`${API.Api}/api/references/localities/${this.filtersWinners.city}`)
          .then(res => {
            this.disabledLocalitiesWinners = false,
                this.localitiesWinners = res.body.data
            this.filtersWinners.school = ''
            this.filtersWinners.locality = ''
          })
    },

    setLocalityWinner() {
      this.$http.get(`${API.Api}/api/references/schools/${this.filtersWinners.locality}`)
          .then(res => {
            this.disabledSchoolsWinners = false,
                this.schoolsWinners = res.body.data
            this.filters.locality = ''
          })
    },
    async setFiltersWinners() {
      if (this.year >= 2022) {
        const params = {}
        for (const key in this.filtersWinners) {
          this.filtersWinners[key] && (params[key] = this.filtersWinners[key])
        }
        const response = await this.$http.get(`${API.Api}/api/winners/second/${this.year}?per_page=10`, {
          params: {
            search: this.searchWinners,
            ...params
          }
        })
        if (response.body) {
          this.fullWinnersSecond = this.year < 2024 ? response.body.data : response.body.data.data.map(item => ({
            fullname: item.user.full_name,
            region: item.user.location.region,
            result: item.results.result,
          }))
          this.metaWinners = {
            links: response.body.data.links,
            total: response.body.data.total,
            current_page: response.body.data.current_page
          }
        } else {
          this.fullWinnersSecond = []
          this.metaWinners = {}
        }
      } else {
        const params = {}
        for (const key in this.filtersWinners) {
          this.filtersWinners[key] && (params[key] = this.filtersWinners[key])
        }
        const response = await this.$http.get(`${API.Api}/api/winners-2021?per_page=10`, {
          params: {
            search: this.searchWinners,
            ...params
          }
        })
        if (response.body) {
          this.fullWinnersSecond = response.body.data
          this.metaWinners = {
            links: response.body.data.links,
            total: response.body.data.total,
            current_page: response.body.data.current_page
          }
        } else {
          this.fullWinnersSecond = []
          this.metaWinners = {}
        }
      }
    },

    async setFilters() {
      const params = {}
      for (const key in this.filters) {
        this.filters[key] && (params[key] = this.filters[key])
      }
      const response = await this.$http.get(`${API.Api}/api/winners/get/${this.year}?per_page=10`, {
        params: {
          search: this.search,
          ...params
        }
      })
      console.log('response 2024', response)
      if (response.body) {
        if (this.year == 2026) {
          this.fullWinners = response.body.data.data
        } else 
        if (this.year == 2025) {
          this.fullWinners = response.body.data.data
        } else if (this.year == 2024) {
          this.fullWinners = response.body.data.data
        } else if (this.year == 2023) {
          this.fullWinners = response.body.data.data
        } else {
          this.fullWinners = response.body.data
          this.meta = {
            links: response.body.data.links,
            total: response.body.data.total,
            current_page: response.body.data.current_page
          }
        }
      } else {
        this.fullWinners = []
        this.meta = {}
      }
    },

    async resetFilters() {
      this.search = ''
      document.getElementById("regions").selectedIndex = 0;
      // document.getElementById("districts").selectedIndex = 0;
      // document.getElementById("localities").selectedIndex = 0;
      // document.getElementById("schools").selectedIndex = 0;
      // document.getElementById("classes").selectedIndex = 0;
      this.filters = {
        region: '',
        city: '',
        locality: '',
        school: '',
        class: ''
      }
      this.disabledDistricts = true;
      this.disabledLocalities = true;
      this.disabledSchools = true;
      this.isFilterFormVisible = false
      const response = await this.$http.get(`${API.Api}/api/winners/get/${this.year}?per_page=10`)
      if (response.body) {
        if (this.year >= 2024) {
          this.fullWinners = response.body.data.data
          this.meta = {
            links: response.body.data.links,
            current_page: response.body.data.current_page,
            total: response.body.data.total,
          }
        } else if (this.year >= 2023) {
          this.fullWinners = response.body.data.data
          this.meta = {
            links: response.body.data.links,
            total: response.body.data.total,
            current_page: response.body.data.current_page
          }
        } else {
          this.fullWinners = response.body.data
          this.meta = {
            links: response.body.data.links,
            total: response.body.data.total,
            current_page: response.body.data.current_page
          }
        }
      } else {
        this.fullWinners = []
        this.meta = {}
      }
    },
    async resetFiltersWinners() {
      this.searchWinners = ''
      this.filtersWinners = {
        region: '',
        city: '',
        locality: '',
        school: '',
        class: ''
      }
      this.disabledDistrictsWinners = true;
      this.disabledLocalitiesWinners = true;
      this.disabledSchoolsWinners = true;
      let response;

      if (this.year == 2021) {
        response = await this.$http.get(`${API.Api}/api/winners-2021?per_page=10`)
      } else {
        response = await this.$http.get(`${API.Api}/api/winners/second/${this.year}?per_page=10&page=1`)
      }

      if (response.body) {
        this.fullWinnersSecond = this.year < 2024 ? response.body.data.data : response.body.data.data.map(item => ({
          fullname: item.user.full_name,
          region: item.user.location.region,
          result: item.results.result,
        }))
        this.metaWinners = {
          links: response.body.data.links,
          total: response.body.data.total,
          current_page: response.body.data.current_page
        }
      } else {
        this.fullWinnersSecond = []
        this.metaWinners = {}
      }
    },

    async getRegions() {
      const response = await this.$http.get(`${API.Api}/api/references/regions/`)
      this.regions = response.body.data;
    },
  },
  updated() {
    const firstTable = $('#firstResult')
    const firstTableResponsive = firstTable.parent()

    const secondResult = $('#secondResult');
    const secondTableResponsive = secondResult.parent()

    const winnerResult = $('#winnerResult');
    const winnerResultResponsive = winnerResult.parent()

    firstTableResponsive[0].scrollLeft = this.scrollVal;
    secondTableResponsive[0].scrollLeft = this.scrollVal;
    winnerResultResponsive[0].scrollLeft = this.scrollVal;
  },
  mounted() {
    this.year = '2026';
    this.getDataMapNew()
    this.checkLanguage();
    this.handleSearch()
    this.yearLabel = this.$t('for-winners.title2').replace('year', this.year)
    // this.getWinners();
    this.getfullWinnersSecond();
    this.historyMapStart();
    this.historyMapStartWinners();
    this.getAreaWinners();
    this.getAreaWinners2();
    // this.getAreaWinners3();
    this.getRegions();
    this.resetFilters();
    this.AreaWinners1 = localStorage.getItem('AREA_WINNERS_1');
    this.AreaWinners2 = localStorage.getItem('AREA_WINNERS_2');
    this.AreaWinners3 = localStorage.getItem('AREA_WINNERS_3');

    const firstResult = $('#firstResult')
    const visibleWidth = firstResult.width();
    const tableWidth = firstResult.parent().width();
    this.scrollValMax = visibleWidth - tableWidth
  }
}
</script>

<style lang="css" scoped>
.filter-map{
 max-width: 220px;
}
.winner-nav .nav-link.active, .winner-nav .nav-item.show .nav-link {
  cursor: unset !important;
}

.btn-active {
  background-color: #1C5FC2 !important;
}
</style>
<style>
.form-control-block {
  display: flex;
  justify-content: space-between;
}

.winner-page .btn-filter-modal {
  padding: 8px 36px;
  height: fit-content;
}

.winners-subtitle {
  color: #495057;
  font-family: 'Roboto', sans-serif;
}

.form-control-item {
  width: 30%;
}

.container-winners-text {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.container-map-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  z-index: 999;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.container-map-buttons {
  display: flex;
  justify-content: space-between;
}

.container-map-button {
  width: 50%;
}

.activeRegion {
  fill: #1C5FC2;;
}

.result {
  overflow: hidden;
}

.result-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#mapTitle {
  max-width: 340px;
  white-space: initial;
  margin: 12px 0;
  min-height: 138px;
  display: flex;
  align-items: center;
  justify-content: center;
}
#mapTitleWinners{
  max-width: 340px;
  white-space: initial;
  margin: 12px 0;
  min-height: 138px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.winner-select {
  border: 1px solid #E6E6E6;
  background-color: #F9F9F9;
  padding: 11px 23px;
  font-size: 14px;
  line-height: 2;
  height: auto;
}

.winner-page .title {
  font-size: 30px;
}

.winner-page p {
  color: #303030;
  font-size: 18px;
}

#canvas {
  display: block;
}

.title-light-blue {
  background: linear-gradient(90deg, #407BFF 0%, #306EE3 8.85%, #1C5FC2 59.38%, #1358B3 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.winner-nav .nav-tabs {
  border: none;
  background-color: #F7F7F7;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
}

.winner-nav .nav-link.active,
.winner-nav .nav-item.show .nav-link {
  border: none;
  border-radius: 0;
  box-shadow: inset 0 -3px 0 #1A5EBF;
  background-color: #F7F7F7;
}

.winner-nav .nav-item {
  margin-bottom: 0;
}

.winner-nav .nav-item:nth-child(1) .nav-link:before {
  content: " ";
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: -2px 6px;
  background: url("/images/grid.svg") no-repeat center;
}

.winner-nav .nav-item:nth-child(2) .nav-link:before {
  content: " ";
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: -2px 6px;
  background: url("/images/grid.svg") no-repeat center;
}

.winner-nav .nav-link {
  font-family: Rubik;
  padding: 16px 20px 16px 44px;
  border: none;
  color: #303030;
  font-size: 16px;
  text-align: left;
  box-shadow: inset 0 -3px 0 #cfd4da;
}

.winner-nav .form-control {
  border-radius: 6px;
  border: 1px solid #CFDCE5;
}

.winner-nav .form-control::placeholder {
  color: #69788C;
  font-size: 14px;
}

.winner-nav input.search-input {
  background: url("/images/search.svg");
  background-repeat: no-repeat;
  background-position: calc(100% - 15px) center;
  padding-right: 13%;
}

.winner-nav .btn-filter {
  border: 1px solid #CFDCE5;
  border-radius: 6px;
  color: #303030;
  transition: all 0.3s linear;
  padding: 9px 7px;
  font-weight: bold;
  font-size: 12px;
}

.winner-nav .btn-filter:hover {
  color: #409EFF;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

.btn-filter-modal {
  padding: 14px 36px;
  font-size: 15px;
  line-height: 18px;
  border: 1px solid #E0E0E0;
  border-radius: 5px;
  font-weight: 500;
  margin-right: 15px;
  transition: all 0.4s linear;
}

.btn-filter-modal:hover {
  box-shadow: 0 0 4px rgba(0, 0, 0, 30);
}

.winner-nav .pagination {
  float: right;
  margin: 8px 0;
}

.winner-nav .pagination a {
  font-size: 14px;
  line-height: 16px;
  color: #69788C;
  padding: 6px 10px;
  border-radius: 6px;
  margin: 0 2px;
  transition: all 0.1s ease;
  cursor: pointer;
}


.winner-nav .pagination a:hover {
  text-decoration: none;
  background: #1A5EBF;
  color: #fff;
  transition: all 0.1s ease;
}

.winner-nav .pagination a:hover path {
  fill: #fff;
}

.winner-nav .pagination .active {
  color: #fff;
  background: #1A5EBF;
}

.winner-nav .pagination .active:hover {
  background: #1A5EBF;
}

.winner-nav .pagination-mobile {
  display: none;
}

.winner-nav .pagination-desktop {
  display: block;
}

.winner-nav .tab-content {
  position: relative;
  z-index: 1;
  box-shadow: 0 0px 8px rgb(0 0 0 / 10%);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.winner-nav .table-response {
  overflow-x: unset;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.winner-nav .table-response::-webkit-scrollbar {
  width: 0;
}

.table-response-helper {
  overflow-x: scroll;
}

.winner-nav .table {
  /*width: 255%;*/
  //width: 130%;
  width: 100%;
}

.winner-nav .table tr td {
  padding: 16px 12px 32px 12px;
}

.winner-nav .border-bottom {
  border-color: #CFDCE5;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #fff;
}

.table-striped tbody tr:nth-of-type(even) {
  background-color: #F5F8FA;
}

.emptyTable {
  width: 100%;
  margin: 30px 0 15px;
  font-weight: 600;
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
}

.ps--active-x > .ps__rail-x {
  background-color: #E6E6E6;
  border-radius: 20px;
  height: 10px;
}

.ps__thumb-x {
  background: linear-gradient(90deg, #407BFF 0%, #306EE3 8.85%, #1C5FC2 59.38%, #1358B3 100%);
  border-radius: 20px;
  height: 10px;
  bottom: 0;
}


.winner-page .title {
  font-size: 30px;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
}

.winner-school {
  display: none;
  padding-top: 40px;
  padding-bottom: 150px;
}

.winner-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.winner-list .card {
  border: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04), 0px 4px 16px rgba(0, 0, 0, 0.08);
  border-radius: 15px;
  padding: 18px 10px;
  min-width: 190px;
  margin-right: 25px;
  margin-bottom: 20px;
}

.winner-list .card:last-child {
  margin-right: 0;
}

.winner-list .card-image {
  height: 95px;
}

.winner-name {
  text-align: center;
  font-size: 16px;
  font-family: 'Roboto Condensed', sans-serif;
  margin-top: 16px;
}



.map-container {
  background: #FFFFFF;
  max-width: 1550px;
  width: 100%;
  padding: 48px 15px;

}

#paper {
  stroke: #fff;
  stroke-width: 1px;
  transition: all .3s linear;
  background: #fff;
  display: flex;
  justify-content: center;
  overflow: hidden;
}
svg{
  stroke: #fff;
  stroke-width: 1px;
  transition: all .3s linear;
}
#paper-winners {
  stroke: #fff;
  stroke-width: 1px;
  transition: all .3s linear;
  background: #fff;
  display: flex;
  justify-content: center;
  overflow: hidden;
}


.map-scroll-area {
  position: relative;
  width: 1000px;
}

/* .map-stat .title {

} */

.map-stat dl {
  margin-left: 35px;
}

.map-stat dt {
  color: #303030;
  font-size: 30px;
  font-weight: bold;
  line-height: 54px;
}

.map-stat dd {
  font-size: 24px;
  line-height: 36px;
}


.form-filter {
  border: 1px solid #E0E0E0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04), 0px 4px 16px rgba(0, 0, 0, 0.08);
  padding: 20px;
  position: absolute;
  top: 60px;
  left: -10px;
  right: -10px;
  transition: all 0.3s linear;
  opacity: 0;
  transform: translateY(-20px);
}

.form-filter.show {
  visibility: visible;
  opacity: 1;
  transform: translateY(0);
}


input[type=range] {
  width: 526px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

input[type=range] {
  width: 36%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

input[type=range]::-webkit-slider-runnable-track {
  height: 10px;
  border-radius: 20px;
  background: #E6E6E6;
}

input[type=range]::-webkit-slider-thumb {
  background: linear-gradient(90deg, #407BFF 0%, #306EE3 8.85%, #1C5FC2 59.38%, #1358B3 100%);
  border-radius: 20px;
  cursor: pointer;
  width: 40%;
  height: 10px;
  margin: 0;
  -webkit-appearance: none;
}


.winner-nav .table .badge {
  border-radius: 28px;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 14px;
}

.winner-nav .table .badge-success {
  background-color: #018837;
  color: #FFFFFF;
}

.winner-nav .table .badge-warning {
  color: #A16600;
  background-color: #FAD059;
}

.winner-nav .table .badge-light {
  color: #424242;
  background-color: #ECECEC;
}

.mapZooming {
  visibility: hidden;
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.hiddenCity {
  visibility: hidden;
}

.hiddenMap {
  visibility: hidden;
}

.table-row {
  max-width: 200px;
}

.visibility-non {
  visibility: hidden;
}

@media (max-width: 1200px) {
  .form-control-item {
    width: 100%;
    margin: 0;
  }

  .form-control-block {
    flex-direction: column;
    gap: 15px;
  }
}

@media (max-width: 1110px) {
  .map-stat {
    width: 100%;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04), 0px 4px 16px rgba(0, 0, 0, 0.08);
    text-align: center;
    margin: 15px;
  }

  #canvas {
    background: linear-gradient(90deg, rgba(64, 123, 255, 0.1) 0%, rgba(48, 110, 227, 0.1) 8.85%, rgba(28, 95, 194, 0.1) 59.38%, rgba(19, 88, 179, 0.1) 100%);
    position: relative;

  }

  .mapZooming {
    top: 55%;
    left: 50%;
    transform: translateX(-50%);
    width: 50%;
    display: flex;
    justify-content: space-between;
    visibility: hidden;
    z-index: -1;
    opacity: 0;
  }


  #mapTitle {
    max-width: 300px;
    white-space: initial;
    margin: 12px 0;
  }
  #mapTitleWinners{
    max-width: 300px;
    white-space: initial;
    margin: 12px 0;
  }

  .map-stat dl {
    display: flex;
    align-content: center;
    justify-content: center;
    margin-bottom: 0;
  }

  .map-stat dl:last-child {
    margin-bottom: 20px;
  }

  .map-stat dt {
    color: white;
    /* width: 100%; */
    text-align: center;
    background: linear-gradient(
        90deg, #407BFF 0%, #306EE3 8.85%, #1C5FC2 59.38%, #1358B3 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .map-stat dd {
    line-height: 54px;
    margin-left: 10px;
    margin-bottom: 0;
  }

  .map-container-wrap {
    box-shadow: none;
  }

  .map-container {
    box-shadow: none;
    margin: 0;
    padding: 48px 32px;
  }
  .filter-map{
    left: 50%;
    transform: translate(-50%, -50%);
    top: 117px!important;
  }
}

@media (max-width: 991px) {

  .mobile-pagination {
    max-width: none;
    margin-right: auto;
    margin-left: auto;
  }

  .winner-page .title {
    margin-top: 45px;
  }

  .table-row {
    max-width: none;
  }

  .filter-map{
    top: 135px!important;
  }
  #mapTitle {
    max-width: 100%;
  }
  #mapTitleWinners{
    max-width: 100%;
  }

  .table thead th {
    vertical-align: top;
  }

  .winner-nav .nav-link {
    text-align: center;
    background: #fff;
  }

  .winner-nav .nav-link.active, .winner-nav .nav-item.show .nav-link {
    background: #fff;
  }

  .map-stat {
    margin: 0;
    padding-bottom: 10px;
  }

  .map-stat dl {
    justify-content: left;
    max-width: 300px;
    margin: 0 auto;
    padding: 0 20px;
  }

}

@media (max-width: 600px) {
  #paper-winners {
    height: 600px;
  }

  #paper-winners svg {
    height: auto !important;
  }

  #paper {
    height: 600px;
  }

  #paper svg {
    height: auto !important;
  }

  /*
  .winner-page .container .title{
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
  }

  .winner-nav .nav-tabs {
    width: 60%;
    margin: 0 auto;
  }
  .winner-nav .pagination{
    float: none;
  }
  .winner-nav .pagination li{
    display: inline-block;
    margin: 0 auto;
  }
  .winner-nav .tab-content {
    box-shadow: 0 0px 8px rgb(0 0 0 / 10%);
    margin-top: 18px;
  }

  .winner-nav .table tr {
    position: relative;
  }

  .winner-nav .table-response {
    margin-left: 45%;
  }

  .winner-nav .table tr th:nth-child(1) {
    position: absolute;
    width: 10%;
    left: 0;
    top: auto;
    border-bottom: 0;
  }
  .winner-nav .table tr th:nth-child(2) {
    position: absolute;
    width: 35%;
    left: 0;
    top: auto;
    margin-left: 10%;
    text-align: center;
    border-bottom: 0;
  }

  .winner-nav .table tr td:nth-child(1) {
    position: absolute;
    width: 10%;
    left: 0;
    top: auto;
    height: 120px;
  }

  .winner-nav .table tr:nth-child(even) td:nth-child(1) {
    background-color: #F5F8FA;
  }

  .winner-nav .table tr:nth-child(even) td:nth-child(2) {
    background-color: #F5F8FA;
  } */
  /* .winner-nav .table tr td:nth-child(2) {
    position: absolute;
    width: 35%;
    margin-left: 10%;
    left: 0;
    top: auto;
    border-top-width: 2px;
    margin-top: -1px;
    height: 120px;
    border-right:1px solid #CFDCE5;
  } */
  .mapZooming {
    top: 80%;
    visibility: visible;
    z-index: 1;
    opacity: 1;
  }

  /* .winner-nav .nav-tabs {
    width: 90%;
  }
  .map-container {
      margin: 0;
      padding-top: 0;
  } */
}
@media (max-width: 480px) {
  .btns-block {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .btns-block .btn-filter-modal {
    margin-right: 0;
  }
}
#paper svg{
  top:50.5px
}
#paper-winners svg{
  top:50.5px
}
</style>
<style>
.winner-image {
  width: 172px;
  height: 172px;
  margin-bottom: 15px;
  border-radius: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.carousel-item-wrap {
  display: flex;
  flex-direction: column;
}

.carousel-item-wrap img {
  display: block;
  margin: auto !important;
}

.carousel-item-wrap div {
  display: block;
  margin: auto !important;
}
</style>
